var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgG(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 25,
    height: 25,
    viewBox: "0 0 25 25",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "evenodd",
    transform: "translate(1 1)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 11.5,
    cy: 11.5,
    r: 11.5,
    stroke: "#B4975A"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#B4975A",
    fillRule: "nonzero",
    d: "M13.733 10.656c.056.301.087.616.087.945 0 2.57-1.721 4.399-4.32 4.399A4.499 4.499 0 0 1 5 11.5C5 9.014 7.014 7 9.5 7a4.32 4.32 0 0 1 3.01 1.173L11.24 9.44v-.003a2.464 2.464 0 0 0-1.74-.68c-1.485 0-2.692 1.254-2.692 2.74 0 1.484 1.207 2.741 2.692 2.741 1.347 0 2.264-.77 2.453-1.828H9.5v-1.755h4.233zm3.36.281V9.531H15.97v1.406h-1.406v1.126h1.406v1.406h1.125v-1.406H18.5v-1.126h-1.406z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgG);
export default __webpack_public_path__ + "static/media/g.d6ff9e209e02cd3bea68e212008146db.svg";
export { ForwardRef as ReactComponent };